import React from 'react';
import { Helmet } from 'react-helmet';
import { Container } from 'semantic-ui-react';
import TopHeader from '../components/TopHeader/TopHeader';
import Footer from '../components/Footer/Footer';
import SEO from '../components/SEO/SEO';
import 'semantic-ui-less/semantic.less';
import '../style.css';
import AboutIntro from '../components/Intro/AboutIntro';
import { BooksDivider } from '../components/Books/BooksDivider';
import { Books } from '../components/Books/Books';
import Interests from '../components/Interests/Interests';
import { InterestsDivider } from '../components/Interests/InterestsDivider';

const AboutMeta = () => (
    <Helmet>
        <title>About | Yahia Bakour</title>
    </Helmet>
);

const About = () => {
    return (
        <Container text>
            <AboutMeta />
            <SEO />
            <TopHeader />
            <br />
            <AboutIntro />
            <br />
            <InterestsDivider />
            <Interests />
            <br />
            <BooksDivider />
            <Books />
            <Footer />
        </Container>
    );
};

export default About;
